<template>
  <div>
    <el-tag
      v-for="(item, index) in examPointArr"
      :key="index"
      closable
      @close="handleClose(item)"
      class="mr-12"
      size="small"
      >{{ item }}</el-tag
    >
    <el-autocomplete
      v-show="autoCompleteVisible"
      size="mini"
      v-model="item"
      value-key="name"
      clearable
      :fetch-suggestions="querySearchAsync"
      :trigger-on-focus="false"
      placeholder="请输入考点"
      @select="e => handleCreate(e.name)"
    >
      <template slot-scope="{ item }">{{ item.name }}</template>
    </el-autocomplete>
  </div>
</template>

<script>
import codeServices from "@/global/service/code.js";
export default {
  props: {
    autoCompleteVisible: {
      default: false,
      type: Boolean
    },
    examPointArr: {
      type: Array
    }
  },
  data() {
    return {
      item: null,
      pagination: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      examPointList: []
    };
  },
  created() {
    const params = {
      name: this.item,
      page: this.pagination.currentPage,
      page_size: this.pagination.pageSize
    };
    this.getExamTags(params);
  },
  methods: {
    getExamTags(params) {
      // @keyup.enter.native="handleCreate(item)"

      codeServices.getQuestionExamTags(params).then(res => {
        this.examPointList = res.list;
        this.pagination.total = res.pagination.total;
        return res.list;
      });
    },
    querySearchAsync(queryString, cb) {
      if (queryString !== "") {
        const params = {
          name: queryString,
          page: 1,
          page_size: 50
        };
        codeServices.getQuestionExamTags(params).then(res => {
          if (res.list && res.list.length) {
            this.examPointList = res.list;
            this.pagination.total = res.pagination.total;
          } else {
            this.examPointList = [];
          }
          cb(this.examPointList);
        });
      }
      // let examPointList = this.examPointList;
      // const params = {
      //   name: queryString,
      //   page: 1,
      //   page_size: 50,
      // };
      // if (queryString !== "") {
      //   setTimeout(() => {
      //     this.getExamTags(params);
      //   }, 200);
      // } else {
      //   examPointList = [];
      // }
      // let results = queryString
      //   ? this.debounce(this.getExamTags(params), 200)
      //   : examPointList;
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   cb(results);
      // }, 30 * Math.random());
    },
    debounce(fn, delay) {
      let timer = null; //借助闭包
      return function() {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(fn, delay); // 简化写法
      };
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    matchArr(val) {
      return item => {
        return val.toLowerCase() == item.toLowerCase();
      };
    },
    handleCreate(val) {
      const index = this.examPointArr.findIndex(this.matchArr(val));
      if (index == -1) {
        this.$emit("updateArr", { val, type: "add" });
        this.item = null;
      } else {
        this.$message.warning("考点重复!");
      }
    },
    handleClose(val) {
      this.$emit("updateArr", { val, type: "close" });
    }
  }
};
</script>

<style></style>
